import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// ENUMS
import { StickyType, StickyVariant } from '../../enums/sticky';

export const StickyStyled = styled.div<{ isScrolled: boolean; type: StickyType }>`
  background-color: ${theme.colors.primary.white};
  overflow: hidden;
  padding: 0;
  border-radius: 8px;
  grid-column-start: 2;
  grid-column-end: 2;
  grid-row-start: 2;
  grid-row-end: 4;
  flex-direction: column;
  font-size: 14px;
  box-sizing: border-box;
  margin-bottom: 40px;

  ${({ isScrolled }) =>
    isScrolled &&
    css`
      @media only screen and (max-width: 1169px) {
        margin-top: 20px;
        margin-left: 40px;
        background: ${theme.colors.primary.white};
      }
      @media only screen and (min-width: 1170px) {
        position: fixed;
        top: 80px;
        background: none;
        min-width: calc(30.2% - 40px);
        padding-right: 40px;
        > div {
          background: ${theme.colors.primary.white};
        }
      }
    `}

  ${({ type }) =>
    type === StickyType.SLIDER &&
    css`
      margin-top: 55px;
      overflow: visible;
    `}
`;

export const StickyContainer = styled.div`
  display: block;
`;

export const Title = styled.div<{ type: StickyType; variant: StickyVariant }>`
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 17px;
  line-height: 32px;
  margin-bottom: 4px;

  ${({ variant, type }) =>
    variant === StickyVariant.OTHER_VAR &&
    css`
      margin-bottom: 34px;
      ${type === StickyType.DEFAULT &&
      css`
        padding: 40px 40px 0;
      `}
    `}
`;

export const StickyBody = styled.div<{ type: StickyType }>`
  display: block;

  ${({ type }) =>
    type !== StickyType.SLIDER &&
    css`
      padding: 0 40px;
      overflow: auto;
      max-height: calc(100vh - 160px);
    `}
`;

export const StickyItemContainer = styled.div<{ type: StickyType }>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  ${({ type }) =>
    type === StickyType.SLIDER &&
    css`
      grid-template-columns: 5% 20% 40% 35%;
    `}
  padding: 28px 0;
  line-height: 1.5em;
  border-bottom: 1px solid ${theme.colors.secondary.gray600};
  cursor: pointer;
`;
